import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=657519ce&scoped=true&"
import script from "./ReviewPage.vue?vue&type=script&lang=ts&"
export * from "./ReviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=657519ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657519ce",
  null
  
)

export default component.exports